export const mapProductToCard = (product) => {
  const badges = [];

  // backend badge
  if (product.badge) badges.push(product.badge);

  // auto low stock or sold out (optional later)
  if (product.stock === 0) badges.push("Sold Out");

  return {
    id: product._id,
    name: product.name,
    price: Number(product.price),
    originalPrice: product.originalPrice || null,
    image: product.images?.[0] || "/placeholder.png",
    badges,
    category: product.category?._id,
    categoryName: product.category?.name,
    description: product.description,
  };
};
